import {
  Directive,
  Input,
  Renderer2,
  ElementRef,
  OnChanges,
  SimpleChanges,
} from '@angular/core';

@Directive({
  selector: '[appDynamicAttributes]',
  standalone: true,
})
export class DynamicAttributesDirective implements OnChanges {
  @Input() appDynamicAttributes: { [key: string]: any };

  constructor(
    private el: ElementRef,
    private renderer: Renderer2
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.appDynamicAttributes) {
      const attributes = changes.appDynamicAttributes.currentValue;
      for (const key in attributes) {
        if (attributes.hasOwnProperty(key)) {
          this.renderer.setAttribute(
            this.el.nativeElement,
            key,
            attributes[key]
          );
        }
      }
    }
  }
}
